import React, {useEffect} from 'react';
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import {closeDrawer} from "../../actions/drawerActions";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import TagReviewHook from "../qd/tags/TagReviewHook";
import ArgoAppBarHook from "../common/ArgoAppBarHook";

function TagReviewDrawerHook({ id }) {
    const dispatch = useDispatch();
    const handleCloseDrawer = () => dispatch(closeDrawer());

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                e.preventDefault()
                handleCloseDrawer()
            }
        }

        document.addEventListener("keydown", handleKeyDown, true)

        return () => {document.removeEventListener("keydown", handleKeyDown, true)}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <ClickAwayListener onClickAway={handleCloseDrawer}>
            <div>
                <ArgoAppBarHook
                    title="Review Tag"
                    showMenuArrowButton="LEFT"
                    onLeftIconButtonTouchTap={handleCloseDrawer}
                    isDrawer={true}
                    width={tagReviewDrawerProps.width}
                />

                <div style={{height: '64px'}}></div>

                <div>
                    <TagReviewHook id={id} width={tagReviewDrawerProps.width}/>
                </div>
            </div>
        </ClickAwayListener>
    );
}

TagReviewDrawerHook.propTypes = {
    templateKey: PropTypes.string,
    id: PropTypes.string
};

const tagReviewDrawerProps = {
    opensecondary: true,
    width: "90%",
    docked: false,
    anchor: "right"
};

export default TagReviewDrawerHook;
export {tagReviewDrawerProps};
